import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";
import Loc from "../services/localization";
import CONFIG_COMPANY from "../services/myConfig";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'date', 'type', 'data'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            title: '',
            users: [],
            hasError: '',
            currentDate: '',
            filter: '',
            trainings: [],

            categories: [],
            showAddCategory: false,
            newCategory: '',
            selectedCategory: "null",
            isLoadingCategory: false,

            trainingMeasures: [],
            showAddMeasures: false,
            newMeasure: '',
            selectedMeasure: "null",
            isLoadingMeasure: false,

            showChooseButton: true,
            dataToEdit: null,
            selectedImage: null,
            selectedImagePreview: null,
            imageUrl: null,
            model: {
                type: '',
                name: '',
                enName: '',
                imageUrl: '',
                videoUrl: '',
                shortDescription: '',
                enShortDescription: '',
                longDescription: '',
                enLongDescription: '',
                category: null,
                resultMeasure: null,
                resultRounds: null
            },
            selectedLanguageIndex: 0,
            languages: [
                {
                    id: 'sr',
                    name: 'Srpski',
                },
                {
                    id: 'en',
                    name: 'English',
                },
            ],
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                if(CONFIG_COMPANY.LANGUAGES != null){
                    this.languages = CONFIG_COMPANY.LANGUAGES;
                }
                this.model.type = this.type;
                this.dataToEdit = this.data;
                this.title = this.dataToEdit == null ? LocService.t('label_add_new_pt_exercise') : LocService.t('label_edit_td')
                if(this.dataToEdit != null){
                    this.model.id =  this.dataToEdit.id
                    this.model.name = this.dataToEdit.name
                    this.model.imageUrl = this.dataToEdit.imageUrl
                    this.imageUrl = this.dataToEdit.imageUrl
                    this.model.videoUrl = this.dataToEdit.videoUrl
                    this.model.enName = this.dataToEdit.enName
                    this.model.shortDescription = this.dataToEdit.shortDescription
                    this.model.enShortDescription = this.dataToEdit.enShortDescription
                    this.model.longDescription = this.dataToEdit.longDescription
                    this.model.enLongDescription = this.dataToEdit.enLongDescription
                    this.model.category = this.dataToEdit.category
                    this.model.resultMeasure = this.dataToEdit.resultMeasure
                    this.model.resultRounds = this.dataToEdit.resultRounds
                }
                this.getAllCategories( true)
                this.getAllMeasures( true)
            }
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeTrainingDefinitionWod')
            this.reset();
            this.trainings = []
            this.currentDate = ''
            this.startAtTime = ''
        },
        reset: reset,
        addTraining: addTraining,
        uploadPhotoBeforeApi: uploadPhotoBeforeApi,
        getAllCategories: getAllCategories,
        deleteCategory: deleteCategory,
        addTypeCategory: addTypeCategory,
        getAllMeasures: getAllMeasures,
        addMeasure: addMeasure,
        deleteMeasure: deleteMeasure,
        loadTextFromFile: loadTextFromFile,
        editTraining: editTraining,
        isSelectedLanguage: isSelectedLanguage,
        handlePasteVideo: handlePasteVideo,
        getChipClassLanguage: getChipClassLanguage,
        onSelectedLanguage: onSelectedLanguage,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small modal--training-editor'
            }else {
                return 'modal--large modal--training-editor'
            }
        },
        preventClose() {
            // Prazna funkcija koja blokira zatvaranje na klik izvan modala
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: #1C242D;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: auto !important; overflow: visible;';
            }
            return 'height: auto !important; overflow: visible;';
        }

    }
}

function handlePasteVideo(event){
    event.preventDefault();
    const pasteText = (event.clipboardData || window.clipboardData).getData("text");

    const videoIdRegex = /(?:https:\/\/www\.youtube\.com\/watch\?v=|https:\/\/youtu\.be\/|embed\/)([a-zA-Z0-9_-]{11})/;
    const match = pasteText.match(videoIdRegex);
    if (match) {
        this.model.videoUrl = `https://www.youtube.com/embed/${match[1]}`;
    } else {
        // Regex za YouTube Shorts
        const shortsRegex =
            /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})(?:\?.*)?$/;
        const matchShorts = pasteText.match(shortsRegex);
        if (matchShorts) {
            this.model.videoUrl = `https://www.youtube.com/embed/${matchShorts[1]}`;
            return;
        }

        const iframeRegex = /<iframe.*?src="https:\/\/player\.vimeo\.com\/video\/(\d+).*?".*<\/iframe>/;
        const matchIframe = pasteText.match(iframeRegex);
        if (matchIframe) {
            this.model.videoUrl = `https://player.vimeo.com/video/${matchIframe[1]}`;
            return
        }
        const vimeoLinkRegex = /https:\/\/vimeo\.com\/(\d+)/;
        const matchLink = pasteText.match(vimeoLinkRegex);

        if (matchLink) {
            this.model.videoUrl = `https://player.vimeo.com/video/${matchLink[1]}`;
            return;
        }
        this.model.videoUrl = pasteText;
    }
}

function formatVimeoLink(input) {
    // Ako je input u obliku iframe
    const iframeRegex = /<iframe.*?src="https:\/\/player\.vimeo\.com\/video\/(\d+).*?".*<\/iframe>/;
    const matchIframe = input.match(iframeRegex);

    if (matchIframe) {
        // Vraća osnovni Vimeo link sa ID videa
        return `https://player.vimeo.com/video/${matchIframe[1]}`;
    }

    // Ako je input jednostavan Vimeo link
    const vimeoLinkRegex = /https:\/\/vimeo\.com\/(\d+)/;
    const matchLink = input.match(vimeoLinkRegex);

    if (matchLink) {
        // Vraća osnovni Vimeo link
        return `https://player.vimeo.com/video/${matchLink[1]}`;
    }

    // Ako nije ni jedan od ovih formata
    return null;
}


function reset(){
    this.dataToEdit = null
    this.isLoading = false;
    this.selectedLanguageIndex = 0;
    this.model = {
        type: '',
        name: '',
        enName: '',
        videoUrl: '',
        shortDescription: '',
        enShortDescription: '',
        longDescription: '',
        enLongDescription: '',
        category: null,
        resultRounds: null,
        resultMeasure: null
    }
    this.selectedCategory= "null";
    this.selectedMeasure= "null";
    this.selectedImage= null;
    this.selectedImagePreview= null;
    this.imageUrl= null;
}


function addTraining(url) {
    let _self = this;
    this.model.imageUrl = url;
    if(this.model.name == null ||
        this.model.name.length === 0){
        swal(LocService.t("label_error"), LocService.t('label_td_name_required'), 'warning')
        return;
    }
    this.model.category = this.selectedCategory != null ? this.selectedCategory.name : null;
    this.model.resultMeasure = this.selectedMeasure != null ? this.selectedMeasure.name : null;
    if(this.dataToEdit != null){
        this.editTraining();
        return;
    }
    AdminApiService.addNewTrainingDefinition(this.model)
        .then((response) => {
            this.isLoading = false;
            swal(LocService.t("label_success"), LocService.t('label_success_added_training_of_the_day'), 'success')
            _self.$topnavbar.$emit('successTrainingDefinitionWod')
            _self.reset();
        })
        .catch(error => {
            this.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function editTraining() {
    let _self = this;
    AdminApiService.editTrainingDefinition(this.model)
        .then((response) => {
            this.isLoading = false;
            swal(LocService.t("label_success"), LocService.t('label_success_edited_training_of_the_day'), 'success')
            _self.$topnavbar.$emit('successTrainingDefinitionWod')
            _self.reset();

        })
        .catch(error => {
            this.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }
}


function uploadPhotoBeforeApi() {
    this.isLoading = true;
    let _self = this;
    if(this.selectedImage == null){
        _self.addTraining(this.imageUrl);
        return
    }
    AdminApiService.uploadImageTrainingDefinition(this.selectedImage)
        .then((response) => {
            _self.addTraining(response.data.url);
        })
        .catch((error) => {
            this.isLoading = false;
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function isSelectedLanguage(item, index){
    return this.selectedLanguageIndex === index
}

function getChipClassLanguage(item, index) {
    if (this.selectedLanguageIndex === index) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function onSelectedLanguage(item, index){
    this.selectedLanguageIndex = index
}

function getAllCategories(firstTime){
    let _self = this;
    AdminApiService.getTrainingDefinitionTypeCategory("CATEGORY")
        .then((response) => {
            _self.categories = response.data
            _self.isLoadingCategory = false
            _self.showAddCategory = false;
            if(firstTime){
                var filtered = _self.categories.filter(c => c.name === _self.model.category)
                if(filtered.length > 0){
                    _self.selectedCategory = filtered[0]
                }
            }
        })
        .catch((error) => {
            this.isLoadingCategory = false;
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function getAllMeasures(firstTime){
    let _self = this;
    AdminApiService.getTrainingDefinitionTypeCategory("MEASURE")
        .then((response) => {
            _self.trainingMeasures = response.data
            _self.isLoadingMeasure = false
            _self.showAddMeasures = false;
            if(firstTime){
                var filtered = _self.trainingMeasures.filter(c => c.name === _self.model.resultMeasure)
                if(filtered.length > 0){
                    _self.selectedMeasure = filtered[0]
                }
            }
        })
        .catch((error) => {
            this.isLoading = false;
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function addTypeCategory(){
    let _self = this;
    let model = {
        name: _self.newCategory,
        type: "CATEGORY"
    }
    if(model.name.length === 0) return;
    _self.isLoadingCategory = true
    AdminApiService.addTrainingDefinitionTypeCategory(model)
        .then((response) => {
            _self.getAllCategories(false);
            _self.newCategory = ""
        })
        .catch((error) => {
            _self.isLoadingCategory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function addMeasure(){
    let _self = this;
    let model = {
        name: _self.newMeasure,
        type: "MEASURE"
    }
    if(model.name.length === 0) return;
    _self.isLoadingMeasure = true
    AdminApiService.addTrainingDefinitionTypeCategory(model)
        .then((response) => {
            _self.getAllMeasures(false);
            _self.newMeasure = ""
        })
        .catch((error) => {
            _self.isLoadingMeasure = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteCategory(){
    let _self = this;
    if(this.selectedCategory == null) return;
    _self.isLoadingCategory = true
    AdminApiService.deleteTrainingDefinitionTypeCategory(this.selectedCategory.id)
        .then((response) => {
            _self.getAllCategories(false);
            _self.selectedCategory = "null"

        })
        .catch((error) => {
            _self.isLoadingCategory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteMeasure(){
    let _self = this;
    if(this.selectedMeasure == null) return;
    _self.isLoadingMeasure = true
    AdminApiService.deleteTrainingDefinitionTypeCategory(this.selectedMeasure.id)
        .then((response) => {
            _self.getAllMeasures(false);
            _self.selectedMeasure = "null"

        })
        .catch((error) => {
            _self.isLoadingMeasure = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/modals/AddTrainingDefinitionPersonal.js